import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.CITY_PLANNER;

export const QUESTION_COUNT_TO_MASTER_LEVEL = 4;
export const ITEMS_PER_ROUND = 4;
export const ONBOARDING_INDEX = 0;
export const QUESTIONS_PER_ROUND = 5;
export const INCORRECT_EVIDENCE_FEEDBACK = 'Hmm.... Let\'s see what you really had in mind.';

// Layout dimensions shared by components and SVG viewBoxes. Path geometry in each SVG
// file is authored for these exact sizes — update paths if these values change.
export const CLAIM_BUTTON_WIDTH = 344;
export const CLAIM_BUTTON_HEIGHT = 111;

export const DASHBOARD_BUBBLE_WIDTH = 281;
export const DASHBOARD_BUBBLE_BASE_HEIGHT = 150;
export const DASHBOARD_BUBBLE_HEIGHT = 210;

// payoff tile states
export const PAYOFF_TILE_STATES = {
  AVAILABLE: 'AVAILABLE',
  SELECTED: 'SELECTED',
  NOT_SELECTED: 'NOT_SELECTED',
};

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  INTRO: 'INTRO',
  CROWD: 'CROWD',
  STANDARD_VIEW: 'STANDARD_VIEW',
  LOADING: 'LOADING',
  DASHBOARD: 'DASHBOARD',
  TILE_PLACEMENT: 'TILE_PLACEMENT',
  TRANSITION: 'TRANSITION',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  INITIALIZE_ROUND: 'INITIALIZE_ROUND',
  INITIALIZE_CROWD: 'INITIALIZE_CROWD',
  NEXT_STANDARD_ITEM: 'NEXT_STANDARD_ITEM',
  INCREMENT_ANSWERED_COUNT: 'INCREMENT_ANSWERED_COUNT',
  SELECT_RESPONSE: 'SELECT_RESPONSE',
  COMPLETE_ONBOARDING: 'COMPLETE_ONBOARDING',
  SET_LEVEL_INDEX: 'SET_LEVEL_INDEX',
  SET_LEVEL_AFTER_ONBOARDING: 'SET_LEVEL_AFTER_ONBOARDING',
  TOGGLE_EVIDENCE_INDEXES: 'TOGGLE_EVIDENCE_INDEXES',
  SET_GAME_MODE: 'SET_GAME_MODE',
  ADD_SELECTED_EVIDENCE: 'ADD_SELECTED_EVIDENCE',
  CORRECT_EVIDENCE_FEEDBACK: 'CORRECT_EVIDENCE_FEEDBACK',
  ADD_SELECTED_CLAIM_ID: 'ADD_SELECTED_CLAIM_ID',
  ROUND_END: 'ROUND_END',
  SET_IS_TEXT_INTRO_PHASE: 'SET_IS_TEXT_INTRO_PHASE',
  SET_IS_TEXT_SCROLLER_AT_THE_BOTTOM: 'SET_IS_TEXT_SCROLLER_AT_THE_BOTTOM',
  SET_PARTICLE_ANIMATION: 'SET_PARTICLE_ANIMATION',
  STOP_PARTICLE_ANIMATION: 'STOP_PARTICLE_ANIMATION',
  INCREMENT_INTRO_TEXT: 'INCREMENT_INTRO_TEXT',
  SET_CURRENT_ARTICLE: 'SET_CURRENT_ARTICLE',
  SET_OPTION_STATE: 'SET_OPTION_STATE',
  SET_PHRASES_DISABLED: 'SET_PHRASES_DISABLED',
  SET_SELECTED_INTEGRATION_OPTION_INDEX: 'SET_SELECTED_INTEGRATION_OPTION_INDEX',
  SET_QUESTION_TYPE: 'SET_QUESTION_TYPE',
  LOAD_LOCALLY_SAVED_LEVEL: 'LOAD_LOCALLY_SAVED_LEVEL',
  CLEAR_LOCALLY_SAVED_LEVEL: 'CLEAR_LOCALLY_SAVED_LEVEL',
  ADD_LEVEL_TO_LOCALLY_SAVED_DATA: 'ADD_LEVEL_TO_LOCALLY_SAVED_DATA',
  INCREASE_ATTEMPT_COUNT: 'INCREASE_ATTEMPT_COUNT',
  QUICK_ROUND: 'QUICK_ROUND',
  UPDATE_RECORDS: 'UPDATE_RECORDS',
};

export const GAME_MODES = {
  CLAIM_SELECTION: 'CLAIM_SELECTION',
  EVIDENCE_SELECTION: 'EVIDENCE_SELECTION',
  EVIDENCE_NO_ATTEMPT: 'EVIDENCE_NO_ATTEMPT',
  EVIDENCE_REVEALED: 'EVIDENCE_REVEALED',
  DASHBOARD: 'DASHBOARD',
  MAKE_DECISION: 'MAKE_DECISION',
  OPTION_SELECTION: 'OPTION_SELECTION',
  FEEDBACK_POSITIVE: 'FEEDBACK_POSITIVE',
  FEEDBACK_NEGATIVE: 'FEEDBACK_NEGATIVE',
};

export const TESTIMONIAL_CONTROLS_PHASES = {
  CLAIM_SCROLLED: 'CLAIM_SCROLLED',
  CLAIM_NOT_SCROLLED: 'CLAIM_NOT_SCROLLED',
  EVIDENCE_SELECT: 'EVIDENCE_SELECT',
  EVIDENCE_SELECTED: 'EVIDENCE_SELECTED',
  EVIDENCE_ALL_SELECTED: 'EVIDENCE_ALL_SELECTED',
  EVIDENCE_REVEALED: 'EVIDENCE_REVEALED',
};

export const QUESTION_TYPES = {
  CLAIM: 'CLAIM',
  EVIDENCE: 'EVIDENCE',
  INTEGRATION: 'INTEGRATION',
};

export const INTRO_BUBBLE_TEXT = {
  BEGINNING_OF_LEVEL: 'Citizens of Babbleburg, we’re all here today to talk about the issues and come to ' +
  'a sensible conclusion about how to run this city.',
  MID_LEVEL: 'Welcome back folks! It\'s time to listen to another opinion and come\n to a conlusion.',
  END_OF_LEVEL: 'We\'ve heard both opinions! Let\'s get to the big finale about how to run this city!',
};
